import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { map, withLatestFrom } from 'rxjs/operators';

import { AuthQuery } from '../auth';
import { User, UserService } from '../user';
import { Category } from './category.model';
import { CategoryStore, CategoryState } from './category.store';

@Injectable()
export class CategoryQuery extends QueryEntity<CategoryState> {
  sortedCategories$ = this.selectAll().pipe(
    withLatestFrom(this.authQuery.user$),
    map(([categories, user]) => this._getSortedCategories(categories, user))
  );
  constructor(protected store: CategoryStore, private authQuery: AuthQuery, private userService: UserService) {
    super(store);
  }

  private _getSortedCategories(categories: Category[], user: User) {
    const userCategories: string[] | null = this.userService.getUserPreference<string[]>('SELECTED_CATEGORIES') || [];
    const selectedCategories: Category[] = [];
    const unselectedCategories: Category[] = [];

    categories.forEach((category) => {
      if (userCategories!.indexOf(category.id) > -1) {
        selectedCategories.push(category);
      } else {
        unselectedCategories.push(category);
      }
    });

    return [...selectedCategories, ...unselectedCategories] as Category[];
  }
}
